<template>
  <mk-drawer
    class="preview"
    :visible="show"
    direction="rtl"
    size="370px"
    hide-header
    :before-close="cancel"
  >
    <div class="header">
      <h3>内容预览</h3>
      <mk-iconfont
        class="icon"
        icon-class="guanbi"
        @click.native="cancel"
      ></mk-iconfont>
    </div>
    <div class="content">
      <h3>{{ title }}</h3>
      <iframe
        id="iframe"
        :src="link"
        frameborder="0"
        @load="renderIframe"
      ></iframe>
    </div>
  </mk-drawer>
</template>

<script>
export default {
  name: 'Preview',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    isIframe: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default () {
        return {
          title: '', // 文章标题
          context: '', // 文章内容
          qrCode: '' // 底部二维码
        }
      }
    }
  },
  data () {
    return {
      link: ''
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    renderIframe () {
      // 渲染iframe
      if (this.isIframe) {
        this.baseDataRenderIframe(this.propData)
      } else {
        this.baseIdRenderIframe(this.id)
      }
    },
    baseIdRenderIframe (articleId) {
      // 根据id拼接url渲染iframe
      const { VUE_APP_M_C_BASE_URL, NODE_ENV } = process.env
      let link = VUE_APP_M_C_BASE_URL
      if (NODE_ENV === 'development') {
        link = location.origin.replace('8087', '8092')
      }
      link += `/h5-article/spread/index.html?artId=${articleId}`
      const user = JSON.parse(window.localStorage.getItem('user')) || {}
      const { id, account, accountName } = user
      link += `&issueId=${account}&accountName=${encodeURIComponent(
        accountName
      )}&view=yes`
      this.link = link
    },
    baseDataRenderIframe (data) {
      // 根据传入数据渲染iframe
      const iframe = document.getElementById('iframe')
      const { VUE_APP_M_C_BASE_URL, NODE_ENV } = process.env
      let link = VUE_APP_M_C_BASE_URL
      if (NODE_ENV === 'development') {
        link = location.origin.replace('8087', '8092')
      }
      link += `/h5-article/spread/index.html?isIframe=1&view=yes`
      this.link = link
      iframe.contentWindow.postMessage(data, link)
    }
  }
}
</script>

<style lang="scss" scoped>
.preview {
  .header {
    height: 60px;
    box-sizing: border-box;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;

    h3 {
      font-size: 16px;
      line-height: 22px;
      color: #262626;
    }

    .icon {
      color: #bfbfbf;
      cursor: pointer;
    }
  }

  .content {
    width: calc(100% - 50px);
    margin: 0 auto;

    h3 {
      font-weight: 500;
      font-size: 16px;
      line-height: 18px;
      margin: 24px 0 16px 0;
    }

    #iframe {
      width: 100%;
      height: calc(100vh - 143px);
      overflow-y: scroll;
    }
  }
}
</style>
